"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetResponseToJSON = exports.AssetResponseFromJSONTyped = exports.AssetResponseFromJSON = void 0;
var Audio_1 = require("./Audio");
var Image_1 = require("./Image");
var Video_1 = require("./Video");
function AssetResponseFromJSON(json) {
    return AssetResponseFromJSONTyped(json, false);
}
exports.AssetResponseFromJSON = AssetResponseFromJSON;
function AssetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign(__assign({}, (0, Audio_1.AudioFromJSONTyped)(json, true)), (0, Image_1.ImageFromJSONTyped)(json, true)), (0, Video_1.VideoFromJSONTyped)(json, true));
}
exports.AssetResponseFromJSONTyped = AssetResponseFromJSONTyped;
function AssetResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    if ((0, Audio_1.instanceOfAudio)(value)) {
        return (0, Audio_1.AudioToJSON)(value);
    }
    if ((0, Image_1.instanceOfImage)(value)) {
        return (0, Image_1.ImageToJSON)(value);
    }
    if ((0, Video_1.instanceOfVideo)(value)) {
        return (0, Video_1.VideoToJSON)(value);
    }
    return {};
}
exports.AssetResponseToJSON = AssetResponseToJSON;
